import { useState, useEffect } from 'react';
import { VakyaHoroscopeService } from '../services/vakya-horoscope-new';

const T = { bg:'#faf8f5', cream:'#ffffff', greenDk:'#8B0000', maroon:'#8B0000', orange:'#e65100', border:'#e0dcd3', header:'linear-gradient(135deg,#8B0000,#4A0000)' };

const CastingPage = () => {
  const [formData, setFormData] = useState({
    name: 'Raman',
    date: '1957-11-28',
    time: '06:10',
    place: 'Vridhachalam',
    latitude: 11.51,
    longitude: 79.32,
    timezone: 5.5,
    language: 'ta'
  });
  const [locations, setLocations] = useState([]);
  const [searchQuery, setSearchQuery] = useState('Vridhachalam');
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetch('/data/locations.json')
      .then(r => r.json())
      .then(data => setLocations(data))
      .catch(e => console.error("Could not load locations", e));
  }, []);

  const handleSearch = (e) => {
    const val = e.target.value;
    setSearchQuery(val);
    if (val.length >= 2) {
      setShowSuggestions(true);
    } else {
      setShowSuggestions(false);
    }
  };

  const selectLocation = (loc) => {
    setFormData({ ...formData, place: loc.name, latitude: loc.lat, longitude: loc.lng });
    setSearchQuery(loc.name);
    setShowSuggestions(false);
  };

  const filteredLocations = locations.filter(l => 
    l.name.toLowerCase().includes(searchQuery.toLowerCase()) || 
    (l.state && l.state.toLowerCase().includes(searchQuery.toLowerCase()))
  ).slice(0, 5);

  const calculate = async () => {
    setLoading(true);
    try {
      const hs = new VakyaHoroscopeService();
      const birthDetails = {
        name: formData.name,
        date: formData.date,
        time: formData.time,
        place: formData.place,
        latitude: parseFloat(formData.latitude),
        longitude: parseFloat(formData.longitude),
        timezone: parseFloat(formData.timezone)
      };
      const res = await hs.calculateHoroscope(birthDetails, formData.language);
      setResult(res);
    } catch (e) {
      console.error(e);
      alert('Error calculating horoscope. Check console for details.');
    }
    setLoading(false);
  };

  return (
    <div style={{background:T.bg,minHeight:'80vh',padding:'10px'}}>
      <div style={{background:T.header,padding:'12px',borderRadius:'10px',textAlign:'center',marginBottom:'10px'}}>
        <div style={{color:'#ffffff',margin:0,fontSize:'1.2rem',fontWeight:900, textShadow:'1px 1px 2px rgba(0,0,0,0.5)'}}>📋 ஜாதகம் கணித்தல்</div>
        <div style={{color:'#ffe0b2',fontSize:'0.85rem'}}>Sri Paranthaman Horoscope Casting</div>
      </div>
      
      {!result ? (
        <div style={{background:T.cream,padding:'15px',borderRadius:'8px',border:'1px solid '+T.border}}>
          
          <div style={{marginBottom:'12px'}}>
            <label style={{fontSize:'0.85rem',fontWeight:700,color:T.greenDk,display:'block',marginBottom:'4px'}}>பெயர் (Name)</label>
            <input type="text" value={formData.name} onChange={e=>setFormData({...formData, name: e.target.value})} style={{width:'100%',padding:'10px',borderRadius:'6px',border:'1px solid #ccc',boxSizing:'border-box'}} />
          </div>

          <div style={{marginBottom:'12px', display:'flex', gap:'10px'}}>
            <div style={{flex:1}}>
              <label style={{fontSize:'0.85rem',fontWeight:700,color:T.greenDk,display:'block',marginBottom:'4px'}}>Date of Birth</label>
              <input type="date" value={formData.date} onChange={e=>setFormData({...formData, date: e.target.value})} style={{width:'100%',padding:'10px',borderRadius:'6px',border:'1px solid #ccc',boxSizing:'border-box'}} />
            </div>
            <div style={{flex:1}}>
              <label style={{fontSize:'0.85rem',fontWeight:700,color:T.greenDk,display:'block',marginBottom:'4px'}}>Time of Birth</label>
              <input type="time" value={formData.time} onChange={e=>setFormData({...formData, time: e.target.value})} style={{width:'100%',padding:'10px',borderRadius:'6px',border:'1px solid #ccc',boxSizing:'border-box'}} />
            </div>
          </div>

          <div style={{marginBottom:'12px', position:'relative'}}>
            <label style={{fontSize:'0.85rem',fontWeight:700,color:T.greenDk,display:'block',marginBottom:'4px'}}>Place of Birth</label>
            <input type="text" value={searchQuery} onChange={handleSearch} onFocus={()=>searchQuery.length>=2 && setShowSuggestions(true)} placeholder="Type to search location..." style={{width:'100%',padding:'10px',borderRadius:'6px',border:'1px solid #ccc',boxSizing:'border-box'}} />
            {showSuggestions && filteredLocations.length > 0 && (
              <div style={{position:'absolute',top:'100%',left:0,right:0,background:'#fff',border:'1px solid #ccc',zIndex:10,maxHeight:'200px',overflowY:'auto',boxShadow:'0 4px 6px rgba(0,0,0,0.1)'}}>
                {filteredLocations.map((l,i)=>(
                  <div key={i} onClick={()=>selectLocation(l)} style={{padding:'10px',borderBottom:'1px solid #eee',cursor:'pointer'}}>
                    <div style={{fontWeight:600,color:T.greenDk}}>{l.name}</div>
                    <div style={{fontSize:'0.75rem',color:'#666'}}>{l.state}, {l.country} ({l.lat}, {l.lng})</div>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div style={{display:'flex',gap:'10px',marginBottom:'12px'}}>
             <div style={{flex:1}}>
                <label style={{fontSize:'0.75rem',fontWeight:700,color:T.greenDk,display:'block',marginBottom:'4px'}}>Latitude</label>
                <input type="number" step="0.01" value={formData.latitude} onChange={e=>setFormData({...formData, latitude: e.target.value})} style={{width:'100%',padding:'8px',borderRadius:'6px',border:'1px solid #ccc',boxSizing:'border-box',background:'#f5f5f5'}} readOnly />
             </div>
             <div style={{flex:1}}>
                <label style={{fontSize:'0.75rem',fontWeight:700,color:T.greenDk,display:'block',marginBottom:'4px'}}>Longitude</label>
                <input type="number" step="0.01" value={formData.longitude} onChange={e=>setFormData({...formData, longitude: e.target.value})} style={{width:'100%',padding:'8px',borderRadius:'6px',border:'1px solid #ccc',boxSizing:'border-box',background:'#f5f5f5'}} readOnly />
             </div>
             <div style={{flex:1}}>
                <label style={{fontSize:'0.75rem',fontWeight:700,color:T.greenDk,display:'block',marginBottom:'4px'}}>Timezone</label>
                <input type="number" step="0.5" value={formData.timezone} onChange={e=>setFormData({...formData, timezone: e.target.value})} style={{width:'100%',padding:'8px',borderRadius:'6px',border:'1px solid #ccc',boxSizing:'border-box'}} />
             </div>
          </div>
          
          <div style={{marginBottom:'15px'}}>
            <label style={{fontSize:'0.85rem',fontWeight:700,color:T.greenDk,display:'block',marginBottom:'4px'}}>Language</label>
            <select value={formData.language} onChange={e=>setFormData({...formData, language: e.target.value})} style={{width:'100%',padding:'10px',borderRadius:'6px',border:'1px solid #ccc',fontWeight:700,boxSizing:'border-box'}}>
              <option value="ta">Tamil (தமிழ்)</option>
              <option value="en">English</option>
            </select>
          </div>

          <button onClick={calculate} disabled={loading} style={{width:'100%',padding:'15px',border:'none',borderRadius:'8px',background:T.maroon,color:'#fff',fontSize:'1.1rem',fontWeight:900,cursor:'pointer',marginTop:'5px',boxShadow:'0 4px 6px rgba(0,0,0,0.1)'}}>
            {loading ? '⏳ Calculating...' : '📋 CALCULATE HOROSCOPE'}
          </button>
        </div>
      ) : (
        <div style={{background:T.cream,padding:'15px',borderRadius:'10px',border:'2px solid '+T.greenDk}}>
          <div style={{textAlign:'center',fontWeight:900,fontSize:'1.2rem',color:T.greenDk,marginBottom:'15px'}}>Horoscope Results</div>
          
          <div style={{background:'#fff',borderRadius:'8px',border:'1px solid #ccc',overflow:'hidden', height: '1000px'}}>
            <iframe 
               id="horoscope-iframe"
               srcDoc={result.htmlOutput} 
               title="Horoscope PDF Layout"
               style={{width: '100%', height: '100%', border: 'none'}}
            />
          </div>

          <div style={{display:'flex', gap:'15px', marginTop:'15px'}}>
            <button onClick={()=>{
              const iframe = document.getElementById('horoscope-iframe');
              if(iframe) {
                iframe.contentWindow.focus();
                iframe.contentWindow.print();
              }
            }} style={{flex:1,padding:'12px',border:'none',background:T.greenDk,borderRadius:'8px',color:'#fff',cursor:'pointer',fontSize:'1rem',fontWeight:700}}>
              🖨️ Print / Save PDF
            </button>
            <button onClick={()=>setResult(null)} style={{flex:1,padding:'12px',border:'2px solid '+T.greenDk,background:'#fff',borderRadius:'8px',color:T.greenDk,cursor:'pointer',fontSize:'1rem',fontWeight:700}}>
              🔄 New Casting
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CastingPage;